import { render, staticRenderFns } from "./Etc.vue?vue&type=template&id=a60becf2&scoped=true"
import script from "./Etc.vue?vue&type=script&lang=js"
export * from "./Etc.vue?vue&type=script&lang=js"
import style0 from "./Etc.vue?vue&type=style&index=0&id=a60becf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60becf2",
  null
  
)

export default component.exports